/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_Upfront_InstallmentsInputs */

const en_case_payment_validation_upfront_installments = /** @type {(inputs: Case_Payment_Validation_Upfront_InstallmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upfront payment cannot have installments.`)
};

const pt_br2_case_payment_validation_upfront_installments = /** @type {(inputs: Case_Payment_Validation_Upfront_InstallmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O pagamento à vista não pode ter parcelas.`)
};

/**
* | output |
* | --- |
* | "Upfront payment cannot have installments." |
*
* @param {Case_Payment_Validation_Upfront_InstallmentsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_upfront_installments = /** @type {((inputs?: Case_Payment_Validation_Upfront_InstallmentsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_Upfront_InstallmentsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_upfront_installments(inputs)
	return pt_br2_case_payment_validation_upfront_installments(inputs)
});